import { PortalGradientColor } from '@nx-frontend/shared/types/portal-colors';
import {
  TailwindClassName,
  hasTailwindClass,
  tailwindGradientDirection,
} from '@nx-frontend/shared/types/tailwind-class-name';

interface getColorBgProps {
  color: PortalGradientColor;
  prefix?: string;
}

export const getColorBgClassNames = ({ color, prefix = '' }: getColorBgProps): string[] => {
  const classNames: string[] = [...getColorStyleClassName(color)];
  if (color.length === 1 || typeof color[1] === 'object') {
    classNames.push(`bg-${color[0]}`);
  } else {
    classNames.push(`from-${color[0]}`, `to-${color[1]}`);
    if (!hasTailwindClass(tailwindGradientDirection, classNames)) {
      classNames.push('bg-gradient-to-b');
    }
  }
  return classNames.map((name) => `${prefix}${name}`);
};

export const getColorStyleClassName = (color: PortalGradientColor): TailwindClassName[] => {
  if (color.length === 1) {
    return [];
  }
  const lastElement = color.slice(-1)[0];
  return (
    typeof lastElement === 'object'
      ? lastElement
      : lastElement && hasTailwindClass(tailwindGradientDirection, [lastElement])
      ? [lastElement]
      : []
  ) as TailwindClassName[];
};
